import Principals from '@/api/resources/principals';

const state = {
  principal: null,
  findSuccess: false,
  passwordRecovered: false,
  validRecoveryToken: null,
};

const getters = {
  currentPrincipal: () => (state.principal),
  findPrincipalSuccess: () => (state.findSuccess),
  toggleRecoveredPassword: () => (state.passwordRecovered),
  isValidRecoveryToken: () => (state.validRecoveryToken),
};

const actions = {
  login({ commit, dispatch }, payload) {
    Principals.login(payload).then((response) => {
      dispatch('createSession', response);
      commit('setPrincipal', response);
      dispatch('removeLoading');
    });
  },
  refreshPrincipal({ commit, dispatch }) {
    Principals.show().then((response) => {
      dispatch('refreshSession', response);
      commit('setPrincipal', response);
    });
  },
  register({ commit, dispatch }, payload) {
    Principals.register(payload).then((response) => {
      commit('setPrincipal', response);
      dispatch('createSession', response);
    });
  },
  logout({ commit, dispatch }) {
    commit('setPrincipal', null);
    dispatch('destroySession');
  },
  findPrincipal({ commit }, payload) {
    Principals.find(payload).then((response) => {
      commit('setPrincipal', response);
      commit('findPrincipalSuccess');
    });
  },
  recoverPassword({ commit }, payload) {
    Principals.recoverPassword(payload).then((response) => {
      commit('setPrincipal', response);
      commit('toggleRecoveredPassword');
    });
  },
  newPassword({ commit }, payload) {
    Principals.newPassword(payload).then((response) => {
      commit('setPrincipal', response);
      commit('toggleRecoveredPassword');
    });
  },
  validatePrincipal({ commit, dispatch }, payload) {
    Principals.validate(payload).then((response) => {
      commit('setPrincipal', response);
      dispatch('createSession', response);
      dispatch('removeLoading');
      commit('findPrincipalSuccess');
    });
  },
  updatePrincipal({ commit, dispatch }, payload) {
    Principals.update(payload).then((response) => {
      dispatch('updateToken', response.token);
      commit('setPrincipal', response);
      dispatch('removeLoading');
      commit('findPrincipalSuccess');
    });
  },
  fetchPrincipal({ commit, dispatch }) {
    dispatch('initLoading');
    Principals.show().then((response) => {
      commit('setPrincipal', response);
      dispatch('removeLoading');
    });
  },
  findPrincipalReset({ commit }) {
    commit('findPrincipalSuccess');
  },
  changeRecoveredPassword({ commit }) {
    commit('toggleRecoveredPassword');
  },
  validRecoveryToken({ commit }, payload) {
    Principals.verifyRecoveryToken(payload).then((response) => {
      commit('setValidRecoveryToken', response);
    });
  },
  deleteAccount({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      Principals.deleteAccount().then((response) => {
        commit('setPrincipal', null);
        dispatch('destroySession');
        return resolve(response);
      }).catch(error => reject(error));
    });
  },
};

const mutations = {
  setPrincipal($state, payload) {
    const stateCopy = $state;
    stateCopy.principal = payload;
  },
  findPrincipalSuccess($state) {
    const stateCopy = $state;
    stateCopy.findSuccess = !stateCopy.findSuccess;
  },
  toggleRecoveredPassword($state) {
    const stateCopy = $state;
    stateCopy.passwordRecovered = !stateCopy.passwordRecovered;
  },
  setValidRecoveryToken($state, payload) {
    const stateCopy = $state;
    stateCopy.validRecoveryToken = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
